import React, { useReducer } from 'react';
import FixesListButton from './Fixes.ListButton';

// REDUX
import { getFixesState } from '@Managers/Redux/AppState/AppState';
import { useAppDispatch, useAppSelector } from '@Managers/Redux/Hooks';

// STYLES
import styles from '../Fixes.scss';

const FixesList: React.FC<{}> = ({}) => {
    const [state, setState] = useReducer((state: {}, newState: {}) => ({ ...state, ...newState }), {});

    const dispatch = useAppDispatch();
    const fixesState = useAppSelector(getFixesState);

    return (
        <>
            <div className={styles.fix_group_list}>
                {fixesState.fixArrayPredefined.map((element, index) => (
                    <FixesListButton key={index} index={index} option={element} predefined={true} />
                ))}
                {fixesState.fixArray.map((element, index) => (
                    <FixesListButton key={index} index={index} option={element} />
                ))}
            </div>
        </>
    );
};

export default FixesList;
